var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalhaFantasia2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 260,
    viewBox: "0 0 214 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 213,
    height: 260,
    rx: 8,
    fill: "#ECE6F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.682 112.44C170.682 149.683 142.821 168.305 109.706 179.106C107.972 179.656 106.089 179.629 104.373 179.031C71.1786 168.305 43.3175 149.683 43.3175 112.44V60.2984C43.3175 58.3228 44.1562 56.4282 45.649 55.0313C47.1419 53.6344 49.1666 52.8496 51.2778 52.8496C67.1984 52.8496 87.0992 43.9111 100.95 32.589C102.637 31.2408 104.782 30.5 107 30.5C109.218 30.5 111.363 31.2408 113.05 32.589C126.98 43.9856 146.802 52.8496 162.722 52.8496C164.833 52.8496 166.858 53.6344 168.351 55.0313C169.844 56.4282 170.682 58.3228 170.682 60.2984V112.44Z",
    fill: "url(#paint0_linear_2162_30766)",
    stroke: "url(#paint1_linear_2162_30766)",
    strokeWidth: 3.91429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.184 89.5437L118.648 111.773L108.946 101.305L130.184 89.5437Z",
    fill: "url(#paint2_linear_2162_30766)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4616 94.6106L92.2521 90.4531L97.4924 98.768L104.043 90.4531L109.283 102.925L134.174 123.713L130.244 137.571L96.1825 133.413L89.6321 134.799C89.6321 134.799 83.0817 144.5 80.4616 144.5C77.8415 144.5 73.9113 126.484 73.9113 118.169C73.9113 109.854 80.4616 94.6106 80.4616 94.6106Z",
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9859 94.7865L89.6321 91.8397L96.6867 100.735C96.6867 100.735 97.4925 104.312 90.9422 105.698C84.3918 107.084 83.0818 111.241 83.0818 111.241L73.9112 118.17C73.9112 118.17 73.4356 108.642 76.0557 101.715C78.6758 94.7885 79.9859 94.7865 79.9859 94.7865Z",
    fill: "url(#paint3_linear_2162_30766)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1215 90.9216C88.909 95.9227 88 98.0002 87.7677 104.983C87.5355 111.965 86 104.561 86 104.561C85.5067 98.8677 86.3284 95.7952 89.3538 90.4999L91.1215 90.9216Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1356 91.5012C83.1625 96.8826 82.768 99.1157 84.1858 105.957C85.6036 112.797 82.3685 105.963 82.3685 105.963C80.549 100.546 80.6244 97.3662 82.3183 91.5075L84.1356 91.5012Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.406 95.4427L124.48 101.817M117.144 109.855C117.144 109.855 126.314 101.54 134.175 87.6821C118.454 93.2254 107.973 101.54 107.973 101.54M106.663 115.398H105.353",
    stroke: "#100F11",
    strokeWidth: 5.24028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6321 123.713C89.6321 126.654 90.7363 129.473 92.7018 131.553C94.6673 133.632 97.3331 134.8 100.113 134.8H120.55L121.336 135.631C122.904 136.962 124.894 137.607 126.897 137.433C128.9 137.259 130.765 136.28 132.107 134.697C133.449 133.115 134.167 131.048 134.113 128.922C134.059 126.797 133.237 124.774 131.816 123.27L107.973 101.54C107.973 93.2254 105.353 87.6821 105.353 87.6821C105.353 87.6821 97.4926 90.4538 97.4926 101.54C87.012 104.312 81.7717 109.855 81.7717 109.855",
    stroke: "#100F11",
    strokeWidth: 5.24028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7717 94.6106C87.012 90.4531 92.2523 90.4531 92.2523 90.4531L97.4926 101.54M92.6191 131.473C92.6191 131.473 87.012 134.799 81.7717 143.114",
    stroke: "#100F11",
    strokeWidth: 5.24028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.47 104.128L143.599 114.131M147.036 107.565L137.034 110.694",
    stroke: "#FBFFE2",
    strokeWidth: 5.24028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M119.694 69.9759L117.213 80.1585M123.545 76.3077L113.362 73.8267",
    stroke: "#FBFFE2",
    strokeWidth: 5.24028,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.502 67.3473L143.808 72.306M147.134 70.6739L142.176 68.9794",
    stroke: "#FBFFE2",
    strokeWidth: 3.93021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0639 202.136V222.5H77.2401L66.8892 207.565H66.7003V222.5H63.6278V202.136H66.4716L76.8324 217.091H77.0213V202.136H80.0639ZM84.3072 222.5V207.227H87.2802V222.5H84.3072ZM84.5856 205.189L86.9123 200.605H90.0444L86.962 205.189H84.5856ZM104.345 207.227L98.8068 222.5H95.625L90.0767 207.227H93.2685L97.1364 218.98H97.2955L101.153 207.227H104.345ZM113.202 222.808C111.697 222.808 110.401 222.487 109.314 221.844C108.234 221.194 107.399 220.283 106.809 219.109C106.225 217.929 105.934 216.547 105.934 214.963C105.934 213.399 106.225 212.02 106.809 210.827C107.399 209.634 108.221 208.702 109.275 208.033C110.335 207.363 111.575 207.028 112.993 207.028C113.855 207.028 114.69 207.171 115.499 207.456C116.308 207.741 117.033 208.188 117.676 208.798C118.319 209.408 118.827 210.2 119.198 211.175C119.569 212.143 119.755 213.319 119.755 214.705V215.759H107.614V213.531H116.841C116.841 212.749 116.682 212.056 116.364 211.453C116.046 210.843 115.598 210.363 115.022 210.011C114.452 209.66 113.782 209.484 113.013 209.484C112.178 209.484 111.449 209.69 110.826 210.101C110.209 210.505 109.732 211.036 109.394 211.692C109.062 212.341 108.897 213.047 108.897 213.81V215.55C108.897 216.571 109.076 217.439 109.434 218.155C109.798 218.871 110.305 219.418 110.955 219.795C111.605 220.167 112.364 220.352 113.232 220.352C113.795 220.352 114.309 220.273 114.773 220.114C115.237 219.948 115.638 219.703 115.976 219.378C116.314 219.053 116.573 218.652 116.752 218.175L119.566 218.682C119.34 219.51 118.936 220.236 118.353 220.859C117.776 221.476 117.05 221.956 116.175 222.301C115.307 222.639 114.316 222.808 113.202 222.808ZM126.026 202.136V222.5H123.053V202.136H126.026ZM137.396 222.5V220.273L144.287 213.134C145.023 212.358 145.629 211.679 146.107 211.095C146.59 210.505 146.952 209.945 147.19 209.415C147.429 208.884 147.548 208.321 147.548 207.724C147.548 207.048 147.389 206.465 147.071 205.974C146.753 205.477 146.319 205.096 145.768 204.831C145.218 204.559 144.598 204.423 143.909 204.423C143.18 204.423 142.544 204.572 142 204.871C141.456 205.169 141.039 205.59 140.747 206.134C140.455 206.677 140.31 207.313 140.31 208.043H137.376C137.376 206.803 137.661 205.719 138.232 204.791C138.802 203.863 139.584 203.144 140.578 202.634C141.572 202.116 142.703 201.858 143.969 201.858C145.248 201.858 146.375 202.113 147.349 202.624C148.33 203.127 149.096 203.817 149.646 204.692C150.196 205.56 150.472 206.541 150.472 207.635C150.472 208.391 150.329 209.13 150.044 209.852C149.766 210.575 149.278 211.38 148.582 212.268C147.886 213.15 146.919 214.221 145.679 215.48L141.632 219.716V219.865H150.8V222.5H137.396Z",
    fill: "#4C4452"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2162_30766",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#683091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2162_30766",
    x1: 107,
    y1: 30.5,
    x2: 107,
    y2: 179.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8B99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2162_30766",
    x1: 130.184,
    y1: 89.5437,
    x2: 107.133,
    y2: 110.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0895825,
    stopColor: "#00A0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560112,
    stopColor: "#FEBE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733047,
    stopColor: "#FF01D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2162_30766",
    x1: 75,
    y1: 110,
    x2: 94.4132,
    y2: 97.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639423,
    stopColor: "#FEBE01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF01D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalhaFantasia2);
export default __webpack_public_path__ + "static/media/Medalha_fantasia_2.e372bd906e5c2e806c359d4d4f7f3d9a.svg";
export { ForwardRef as ReactComponent };